module.exports = __webpack_public_path__ + "static/assets/22de57330eb2506f12b958465555406e.svg";